import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isPersonalSynthesisRetrievalRequestFailure() {
      return getState().request.isFailure;
    },
    isPersonalSynthesisRetrievalRequestPending() {
      return getState().request.isPending;
    },
    isPersonalSynthesisRetrievalRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getPersonalSynthesis() {
      return getState().synthesis;
    },
  };
}

export { createSelector };
